module.exports = __webpack_public_path__ + "img/caja4.bf69d432.png";